import React from 'react';
import { Menu, X, Leaf } from 'lucide-react';

interface HeaderProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onNavigateHome: () => void;
}

export default function Header({
  isOpen,
  setIsOpen,
  onNavigateHome,
}: HeaderProps) {
  return (
    <header 
      className="fixed top-0 left-0 right-0 bg-green-50/80 backdrop-blur-sm" 
      style={{ zIndex: 2000 }}
      role="banner"
    >
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <button
          onClick={onNavigateHome}
          className="flex items-center gap-2 hover:text-green-700 transition-colors"
          aria-label="Gå til forsiden"
        >
          <Leaf className="w-6 h-6 text-green-700" aria-hidden="true" />
          <span className="font-semibold text-green-900">
            Signalbakken i Aalborg
          </span>
        </button>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 hover:bg-green-100 rounded-full transition-colors"
          aria-label={isOpen ? "Luk hovedmenu" : "Åbn hovedmenu"}
          aria-expanded={isOpen}
          aria-controls="main-navigation"
        >
          {isOpen ? 
            <X className="w-6 h-6" aria-hidden="true" /> : 
            <Menu className="w-6 h-6" aria-hidden="true" />
          }
        </button>
      </div>
    </header>
  );
}
